export default "__VITE_ASSET__DVP7NrWV__"